import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { categories, articleLinks } from "@/mocks/categories";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      <div className="bg-background-50/90 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                O
              </div>
              <span className="text-foreground-900 font-semibold text-base hidden sm:block">
                OOPBuy Spreadsheet
              </span>
            </a>

            <nav className="hidden md:flex items-center gap-5">
              <a href="/" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors whitespace-nowrap">
                Startseite
              </a>
              <a href="/artikel/oopbuy-spreadsheet-guide" className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors whitespace-nowrap">
                Einkaufsguide
              </a>
              <div className="relative group">
                <span className="text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                  Artikel
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
                <div className="absolute top-full right-0 mt-2 w-64 bg-background-50 border border-background-200/70 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 max-h-64 overflow-y-auto">
                  {articleLinks.map((a) => (
                    <button
                      key={a.slug}
                      onClick={() => { navigate(`/artikel/${a.slug}`); }}
                      className="w-full text-left px-4 py-2.5 text-foreground-700 hover:bg-background-100 text-xs transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {a.title}
                    </button>
                  ))}
                </div>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                OOPBuy Spreadsheet
              </a>
            </nav>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menü öffnen"
            >
              <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
            <div className="px-4 py-4 flex flex-col gap-1">
              <a href="/" className="text-foreground-700 text-sm font-medium py-2.5 whitespace-nowrap" onClick={() => setMobileOpen(false)}>
                <span className="flex items-center gap-2">
                  <i className="ri-home-line text-foreground-500"></i>
                  Startseite
                </span>
              </a>

              <div className="border-t border-background-100 my-2"></div>
              <p className="text-foreground-400 text-xs font-semibold px-1 py-1">KATEGORIEN</p>
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 text-sm py-2.5 pl-2 whitespace-nowrap flex items-center gap-2 hover:text-primary-500 transition-colors"
                  onClick={() => setMobileOpen(false)}
                >
                  <div className="w-6 h-6 flex items-center justify-center rounded bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${cat.icon} text-xs`}></i>
                  </div>
                  {cat.nameDe}
                </a>
              ))}

              <div className="border-t border-background-100 my-2"></div>
              <p className="text-foreground-400 text-xs font-semibold px-1 py-1">ARTIKEL</p>
              {articleLinks.map((a) => (
                <button
                  key={a.slug}
                  onClick={() => { navigate(`/artikel/${a.slug}`); setMobileOpen(false); }}
                  className="text-foreground-600 text-sm py-2.5 pl-2 text-left whitespace-nowrap hover:text-primary-500 transition-colors cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-article-line text-foreground-500"></i>
                    {a.title.length > 35 ? a.title.slice(0, 35) + "..." : a.title}
                  </span>
                </button>
              ))}

              <div className="border-t border-background-100 my-2"></div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 rounded-full text-sm font-medium text-center transition-colors whitespace-nowrap cursor-pointer mt-2"
                onClick={() => setMobileOpen(false)}
              >
                Buy It Now
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}